import React, { FC } from 'react';

import { useTranslation } from 'react-i18next';
import { useRefinementList } from 'react-instantsearch-hooks-web';

import { CustomAccordion } from '../../../../components/CustomAccordion';
import { DURATION_FILTER, DURATION_FILTER_ORDER } from '../../const';
import { FilterItem } from '../FilterItem';
import { SearchInput } from '../SearchInput';
import ShowMoreBtn from './ShowMoreBtn';
import useStyles from './style';

interface RefinementListProps {
  showMore?: boolean;
  hidden?: boolean;
  attribute: string;
  searchable?: boolean;
  delay?: number;
  limit?: number;
  showMoreLimit?: number;
}

export const RefinementList: FC<RefinementListProps> = ({
  showMore = false,
  limit,
  attribute,
  searchable = false,
  delay = 0,
  hidden = false,
  showMoreLimit,
}) => {
  const { items, refine, searchForItems, isFromSearch } = useRefinementList({
    attribute: attribute,
    showMoreLimit,
  });

  const { t } = useTranslation();
  const classes = useStyles();
  const itemsToShow = showMore && limit ? limit : items.length;

  const filtersToShow =
    attribute !== DURATION_FILTER
      ? items
      : // @ts-ignore
        items.sort((a, b) => {
          const aIndex = DURATION_FILTER_ORDER.indexOf(a?.label);
          const bIndex = DURATION_FILTER_ORDER.indexOf(b?.label);
          return (a.isRefined && aIndex - bIndex) || b.isRefined || aIndex - bIndex;
        });

  return !hidden ? (
    <>
      {searchable && <SearchInput handleSearch={searchForItems} isFromSearch={isFromSearch} />}
      {filtersToShow && filtersToShow.length > 0 ? (
        showMore ? (
          <CustomAccordion itemsToShow={itemsToShow} ButtonComponent={ShowMoreBtn} delay={delay}>
            {filtersToShow.map((item) => (
              <FilterItem
                key={item.label}
                label={item.label}
                value={item.value}
                refine={refine}
                isRefined={item.isRefined}
                count={item.count}
                filterValue={attribute}
              />
            ))}
          </CustomAccordion>
        ) : (
          filtersToShow.map((item) => (
            <FilterItem
              key={item.label}
              label={item.label}
              value={item.value}
              refine={refine}
              isRefined={item.isRefined}
              count={item.count}
              filterValue={attribute}
            />
          ))
        )
      ) : (
        <div className={classes.noItems}>{t('page.discover.noFiltersAvailable')}</div>
      )}
    </>
  ) : (
    <></>
  );
};

export default RefinementList;
